





























































import Vue from "vue";
import DateInput from "@/components/DateInput.vue";
import ApiSearch from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import { CashPreAccLookups } from "../models/CashPreAccounting";

interface Data {
  periodId: number | null;
  ready: boolean;
  defaultsApplied: boolean;
}

interface Methods {
  ensureFilters(): void;
  applyDefaultSelections(): void;
  onPeriodChange(): void;
  syncPeriodFromDates(): void;
}

interface Computed {
  filters: any;
  accStatusOptions: any[];
  periodOptions: any[];
}

interface Props {
  apiSearch: ApiSearch;
  lookups: CashPreAccLookups | null;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    DateInput,
  },

  props: {
    apiSearch: { type: Object as () => ApiSearch },
    lookups: { type: Object as () => CashPreAccLookups | null, default: null },
  },

  data() {
    return {
      periodId: null,
      ready: false,
      defaultsApplied: false,
    };
  },

  created() {
    this.ensureFilters();
    this.applyDefaultSelections();
    this.syncPeriodFromDates();
  },

  watch: {
    lookups() {
      this.applyDefaultSelections();
      this.syncPeriodFromDates();
    },
  },

  methods: {
    ensureFilters() {
      const filter = (this.$props.apiSearch as any).filter as FilteringModel;
      if (!filter) return;

      const template = new FilteringModel()
        .value("startDate")
        .value("endDate")
        .multiSelect("selectedAccStatuses", [], false);

      let statusesCreated = false;
      Object.entries(template.filters).forEach(([key, value]) => {
        if (!filter.filters[key]) {
          Vue.set(filter.filters, key, value);
          if (key === "selectedAccStatuses") statusesCreated = true;
        }
      });

      // persistFilters: ha a státusz-pipák kulcsa már a visszatöltött modellből jött, a mentett
      // kijelölés marad, a K2D-alapállapot nem íródik rá (a folyószámla panel mintája)
      if (!statusesCreated) this.defaultsApplied = true;

      this.ready = true;
    },

    // K2D-hű alapállapot: az időszak ÜRESEN indul (a K2D em_tol/em_ig sincs
    // inicializálva), a kontír státuszból viszont MINDEN pipálva
    // (dw_status retrieveend: kivalaszt = '+')
    applyDefaultSelections() {
      if (this.defaultsApplied) return;
      if (!this.$props.lookups) return;
      if (!this.filters.selectedAccStatuses) return;

      this.filters.selectedAccStatuses.selectedOptions = this.accStatusOptions.map(
        (x: any) => x.value
      );

      this.defaultsApplied = true;
    },

    onPeriodChange() {
      const period = (this.$props.lookups?.periods ?? []).find((x: any) => x.id === this.periodId);
      if (!period) return;
      this.filters.startDate.value = period.fromDate;
      this.filters.endDate.value = period.toDate;
    },

    // Visszatöltött (persistFilters) időszak-dátumoknál az időszak-választó is a megfelelő
    // periódusra álljon
    syncPeriodFromDates() {
      const from = this.filters.startDate?.value;
      const to = this.filters.endDate?.value;
      if (!from || !to) return;
      const period = (this.$props.lookups?.periods ?? []).find((x: any) => x.fromDate === from && x.toDate === to);
      if (period) this.periodId = period.id;
    },
  },

  computed: {
    filters(): any {
      return (this.$props.apiSearch as any).filter?.filters ?? {};
    },

    accStatusOptions(): any[] {
      return (this.$props.lookups?.accStatuses ?? []).map((x: any) => ({
        text: x.name,
        value: String(x.id),
      }));
    },

    periodOptions(): any[] {
      return (this.$props.lookups?.periods ?? []).map((x: any) => ({
        text: x.nicName,
        value: x.id,
      }));
    },
  },
});
